export const IMAGE_SELECTOR = 'img';
export const IMAGE_CONTAINER_SELECTOR = '.img__container-one';
